export const columnDefs = [{
  headerName: "Group Name",
  field: "groupName",
  editable: true,
  cellStyle: { 'text-align': 'left' },
}, {
  headerName: "Group Leader",
  field: "groupLeader",
  editable: true,
  cellStyle: { 'text-align': 'left' },
}, {
  headerName: "Men/Women's Culture",
  field: "groupGender",
  editable: true,
  cellStyle: { 'text-align': 'left' },
}, {
  headerName: "Group Type",
  field: "groupType",
  editable: true,
  cellStyle: { 'text-align': 'left' },
}];

export const defaultColumnDefs = {
  sortable: true,
};
